var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scrollable-wrapper"},[_c('div',{ref:"scrollbar",staticClass:"scrollbar",style:(("height: " + _vm.height + ";max-height: " + _vm.maxHeight + ";")),on:{"scroll":_vm.onScrollY}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }